module.exports = __webpack_public_path__ + "img/PM_A02_back_diagonal_en.658d8034.png";